<template>
  <b-table striped hover responsive :sticky-header="maxHeight" :items="items" :fields="fields" @row-clicked="onClick">

    <template v-slot:cell(status)="data">
      <div class="ticket-status d-flex align-items-center align-self-center">
        <!-- <span v-if="enableMultiSelect" class="mr-3 d-flex align-self-center"><b-checkbox v-model="data.item.selected" /></span> -->
        <span class="ticket-status-name px-4 py-1 mr-3" :style="statusColor(data.value)">{{data.value}}</span>
        <span class="d-flex align-self-center">
          <div class="ticket-square" :class="data.item.isStar ? 'ticket-star-dark' : 'ticket-star-light'"></div>
          <!-- <img src="@/assets/star-dark.svg" width="20" height="20"> -->
        </span>
      </div>
    </template>

    <template v-slot:cell(dueDate)="data">
      <div class="mr-4">{{(data.value) ? moment(data.value).fromNow() : "" }}</div>
    </template>

    <template v-slot:cell(updatedAt)="data">
      <div class="d-flex">
        <div class="mr-4">{{moment(data.value).fromNow()}}</div>
        <span><div class="btn round-btn" :class="isStatusOpenSolved(data.item.status) ? 'btn-danger' : 'btn-secondary'"></div></span>
        <!-- todo: would be nice to have the above dot right-justified -->
      </div>
    </template>

    <template v-slot:cell(title)="data">
      <div class="subject">{{data.value}}</div>
    </template>

    <template v-slot:cell(priority)="data">
      <div :style="priorityColor(data.value)">{{data.value}}</div>
    </template>
  </b-table>
</template>

<script>
import Moment from "moment";

export default {
  name: "Tablelist",
  data() {
    return {
      selections: [],
      fields: [
        {
          key     : "status",
          label   : "Status",
          sortable: true
        },
        {
          key     : "ticketNumber",
          label   : "Ticket #",
          sortable: true
        },
        {
          key     : "title",
          label   : "Subject",
          sortable: true
        },
        {
          key     : "assignedTo",
          label   : "Assignee",
          sortable: true
        },
        {
          key     : "client.clientName",
          label   : "Client",
          sortable: true
        },
        {
          key     : "priority",
          label   : "Priority",
          sortable: true
        },
        {
          key     : "ticketType",
          label   : "Ticket Type",
          sortable: true
        },
        {
          key     : "dueDate",
          label   : "Due Date",
          sortable: true
        },
        {
          key     : "updatedAt",
          label   : "Last Updated",
          sortable: true
        }
      ]
    };
  },
  methods: {
    moment(d) {
      return Moment(d);
    },
    onClick(item, index, event) {
      let list = [];
      this.items.forEach( function( item ) {
        if( item.selected ) {
          list.push( item._id );
        }
      })

      if( list.length > 0 ) {
        this.$emit( "listClick" , list );
      } else {
        this.$emit("click", item._id || item.ticketNumber);
      }
    },
    statusColor(status) {
      let color;

      if (status === "open") {
        color = "forestgreen";
      } else if (status === "new") {
        color = "orange";
      } else if (status === "parked") {
        color = "lightgray";
      } else if (status === "in-process") {
        color = "fuchsia";
      } else {
        color = "black";
      }

      return "background-color:" + color + ";";
    },

    priorityColor(priority) {
      let color;
      if (priority === "normal") {
        color = "forestgreen";
      } else if (priority === "high") {
        color = "firebrick";
      } else if (priority === "low") {
        color = "lightgray";
      } else if (priority === "critical") {
        color = "fuchsia";
      } else {
        color = "black";
      }

      return "background-color:" + color + ";color:white;";
    },

    isStatusOpenSolved(status) {
      if (status === "open") {
        return true;
      } else if (status === "solved") {
        return true;
      } else {
        return false;
      }
    }
  },
  props: {
    items            : { type: Array, default: () => [] },
    maxHeight        : { type: String, default: "700px"},
    enableMultiSelect: { type: Boolean, default: false }
  }
};
</script>

<style lang="scss">
.table {
  text-transform: capitalize;
  cursor:pointer;

  thead {
    white-space: nowrap;
    color: #7d7b79;
  }
  th {
    padding: 6px;
    min-width: 100px;
  }
  td {
    vertical-align: middle;
    padding: 8px 10px;
    white-space: nowrap;
    font-size: 15px;
  }

  .ticket-status {
    width: 130px;
    text-align: center;
    font-size: 0.7em;
    font-weight: 700;
    border-radius: 0.25em;
    color: #ffffff;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    text-transform: uppercase;
    box-sizing: border-box;

    .ticket-status-name {
      min-width:110px;
    }

    // show-hand is a global "cursor" to hand display (pointer)  (90px doesn't allow "complete" to be centered correctly )
    // .show-hand {
    //   min-width: 90px;
    // }
  }

  .btn {
    &.round-btn {
      display:flex;
      height: 15px;
      width: 15px;
      border-radius: 50%;
      margin-top:4px;
      padding: 4px;
    }
  }

  .subject {
    display:flex;
    text-align:left;
    width:300px;
    overflow: hidden;
    text-overflow: ellipsis;
    // display: inline-block;
    text-transform: initial;
    font-weight: 600;
  }

  .ticket-square {
    vertical-align: top;
    display: inline-block;
    height: 35px;
    width: 35px;
    color: gold;
    font-size: 24pt;
    vertical-align: middle;
    text-align: center;
    // cursor: pointer;
    background-size: 52%;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;

    &.ticket-star-light {
      background-image: url("../assets/star.svg");
      // &:hover{
      //   background-image: url('../assets/star-dark.svg');
      // }
    }
    &.ticket-star-dark {
      background-image: url("../assets/star-dark.svg");
    }
  }
}
.table.b-table > thead > tr > [aria-sort]:not(.b-table-sort-icon-left),
.table.b-table > tfoot > tr > [aria-sort]:not(.b-table-sort-icon-left) {
  outline: none;
}
</style>